// This is the entry point for the home component
import React, { FC, useCallback, useContext, useEffect } from 'react';
// Redux
import { Dispatch } from 'redux';

// Actions

// Components
import MultiSelect from 'Components/MultiSelect';

// Utils
import { areEqual } from 'Utils/areEqual';
import { ProductAnalyticsContext } from 'Context/ProductAnalytics';
import withErrorBoundary from 'HOC/ErrorBoundary';
import { setIntendedMajorValue } from '../actions/prospectProfile.actions';

interface Props {
  intendedMajor: any[];
  majors: any[];
  dispatch: Dispatch<any>;
}

const IntendedMajorContainer: FC<Props> = (props: Props) => {
  const { intendedMajor, majors, dispatch } = props;

  const {
    filterTrackingHelpers: {
      Listmembership: { listLabels },
    },
    actions: { filterTrack },
  } = useContext(ProductAnalyticsContext);

  useEffect(() => {
    if (intendedMajor.length > 0)
      filterTrack({
        filterCategory: 'Prospect Profile',
        filterName: 'Intended Major',
        filterValue: listLabels(intendedMajor),
        addToStore: true,
      });
  }, [intendedMajor.length]);

  const intendedMajorCallback = (value: any) => {
    setIntendedMajorValue(dispatch, value);
  };

  const onDropdownChangeIntendedMajor = (event: any) => {
    let newSelected = [...intendedMajor];
    if (
      intendedMajor.some((option: any) => {
        return areEqual(event.target.value, option);
      })
    ) {
      newSelected = newSelected.filter(
        (option) => !areEqual(event.target.value, option)
      );
    } else {
      newSelected.push(event.target.value);
    }
    intendedMajorCallback(newSelected);
  };

  return (
    <MultiSelect
      selectedOptions={intendedMajor}
      items={majors}
      onDropdownChange={useCallback(onDropdownChangeIntendedMajor, [
        intendedMajor,
      ])}
      selectionDescription={(intendedMajor.length > 1 && 'Majors') || 'Major'}
      placeholder="Search Major"
    />
  );
};

export default withErrorBoundary(IntendedMajorContainer);
